import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';
import { FileSaverService } from 'ngx-filesaver';
import { ToastrService } from 'ngx-toastr';
@Component({
  selector: 'app-canvas',
  templateUrl: './canvas.component.html',
  styleUrls: ['./canvas.component.scss']
})
export class CanvasComponent implements OnInit {
  @ViewChild('fileForm') fileForm: ElementRef;
  @ViewChild('canvas', { static: true })
  canvas;
  private ctx: CanvasRenderingContext2D;
  img:HTMLImageElement = new Image();
  fileToUpload:File = null;
  frameW:number;
  frameH:number;
  options:any = "3to4";
  constructor(private _FileSaverService: FileSaverService, private toastr: ToastrService, private translate:TranslateService) { }

  ngOnInit(): void {
    this.ctx = this.canvas.nativeElement.getContext('2d');
  }


  imgUploaded(file: FileList, result)  {
    this.fileToUpload = file.item(0)
    this.img.src= URL.createObjectURL(this.fileToUpload);
    this.img.onload = () => {
      if (this.options === '3to4') {
        this.frameW = this.img.width / 3
      this.frameH = this.img.height / 4
         this.ctx.canvas.height = this.frameH * 4;
      this.ctx.canvas.width = this.frameW * 4;
      } else {
        this.frameW = this.img.width / 4
      this.frameH = this.img.height / 4
        this.ctx.canvas.height = this.frameH * 4;
      this.ctx.canvas.width = this.frameW * 3;
      }

      this.draw()
      this.fileForm.nativeElement.value = ''
    }

  }
  draw():void {

    this.ctx.drawImage(this.img,0,0)
    this.ctx.save()
    switch (this.options) {
      case "3to4":
        this.drawFourColumn()
      break

      case "4to3":
        this.drawThreeColumn()
      break
    }

  }

  drawFourColumn():void {
    let duplicatedArea = this.ctx.getImageData(this.frameW+1,0,this.frameW,this.frameH * 4)
    let entitiesTransformed = new Image();
    entitiesTransformed.src = this.getImageURL(duplicatedArea, this.frameW,this.frameH * 4)
    this.ctx.putImageData(duplicatedArea,(this.frameW * 3 +1),0);
    let text:string;
    if (this.translate.currentLang === "en") text = "Spritesheet saved !";
    else text = "Spritesheet enregistré !"
    this.toastr.success(text);
    this.ctx.canvas.toBlob((blob) => {
      const name = this.fileToUpload.name.split('.')[0] + '_entitiesConvertor'
      this._FileSaverService.save(blob, name)
      window.location.reload()
    })
  }

  drawThreeColumn():void {
    this.ctx.canvas.style.width = this.frameW * 3 + 'px'
    this.ctx.canvas.style.height = this.frameH * 3 + 'px'
    this.ctx.canvas.toBlob((blob) => {
      const name = this.fileToUpload.name.split('.')[0] + '_entitiesConvertor'
      this._FileSaverService.save(blob, name)
      window.location.reload()
    })
  }

  getImageURL(imgData, width, height) {
    var canvas = document.createElement('canvas');
    var ctx = canvas.getContext('2d');
    canvas.setAttribute('id','test')
    canvas.width = width;
    canvas.height = height;
    ctx.putImageData(imgData, 0, 0);
    return canvas.toDataURL(); //image URL
 }
}
